import { createApi } from "@reduxjs/toolkit/query/react";
import EnhancedBaseQuery from "./createApiConfig";

const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: EnhancedBaseQuery,
    endpoints: (builder) => ({
        getUserInfo: builder.mutation({
            query: () => ({
                url: "user/UserList",
                method: "GET",
            }),
        }),
        getStudentDetails: builder.mutation({
            query: () => ({
                url: "student/StudentDetailsList",
                method: "GET",
            }),
        }),
        getPoints: builder.mutation({
            query: () => ({
                url: "Dashboard/TotalCount",
                method: "GET",
            }),
        }),
        getBadges: builder.mutation({
            query: () => ({
                url: "badges/BadgesMasterList",
                method: "GET",
            }),
        }),
        getCourseMaster: builder.mutation({
            query: () => ({
                url: "Course/CourseMasterList",
                method: "GET",
            }),
        }),
        getCourseSubDetail: builder.mutation({
            query: () => ({
                url: "Course/CourseSubDetailsList",
                method: "GET",
            }),
        }),
        // course sub detail by id
        getCourseSubDetailsByCourseIdList: builder.mutation({
            query: (courseId) => ({
                url: `Course/CourseSubDetailsByCourseIdList?courseid=${courseId}`,
                method: "GET",
            }),
        }),
        getCourseDetail: builder.mutation({
            query: () => ({
                url: "Course/CourseDetailsList",
                method: "GET",
            }),
        }),
        getCourseDetailsListById: builder.mutation({
            query: (courseId) => ({
                url: `Course/CourseDetailsListById?courseId=${courseId}`,
                method: "GET",
            }),
        }),
        getCourseTrackStart: builder.mutation({
            query: (courseStartConfig) => ({
                url: "Course/CourseTrackStart",
                method: "POST",
                body: courseStartConfig,
            }),
        }),
        getCourseTrackEnd: builder.mutation({
            query: (courseEndConfig) => ({
                url: "Course/CourseTrackEnd",
                method: "POST",
                body: courseEndConfig,
            }),
        }),
        getCourseTrackList: builder.mutation({
            query: () => ({
                url: "Course/CourseTrackList",
                method: "GET",
            }),
        }),
        // ---------------- Course Subscription API ----------------
        getCourseSubscriptionList: builder.mutation({
            query: () => ({
                url: "CourseSubscription/CourseSubscriptionList",
                method: "GET",
            }),
        }),
        // ---------------- Course Subscription API ----------------
        getQuizMaster: builder.mutation({
            query: () => ({
                url: "quiz/QuizMasterList",
                method: "GET",
            }),
        }),
        getQuizQuestionList: builder.mutation({
            query: () => ({
                url: "quiz/QuizQuestionList",
                method: "GET",
            }),
        }),
        getQuizQuestionByQuizIdList: builder.mutation({
            query: (quizId) => ({
                url: `quiz/QuizQuestionByQuizIdList?quizId=${quizId}`,
                method: "GET",
            }),
        }),
        getQuizResponse: builder.mutation({
            query: (quizResponseConfig) => ({
                url: "quiz/QuizResponse",
                method: "POST",
                body: quizResponseConfig,
            }),
        }),
        getQuizResponseList: builder.mutation({
            query: () => ({
                url: "quiz/QuizResponseList",
                method: "GET",
            }),
        }),
        // ---------------- SSPI API ----------------
        // sspiExamList
        getSspiExamList: builder.mutation({
            query: () => ({
                url: "Sspi/SspiExamList ",
                method: "GET",
            }),
        }),
        // Sspi/SspiSubjectList
        getSspiSubjectList: builder.mutation({
            query: () => ({
                url: "Sspi/SspiSubjectList",
                method: "GET",
            }),
        }),
        // Sspi/SspiQuestionList
        getSspiQuestionList: builder.mutation({
            query: () => ({
                url: "Sspi/SspiQuestionList",
                method: "GET",
            }),
        }),
        // Sspi/SspiMasterList
        getSspiMasterList: builder.mutation({
            query: () => ({
                url: "Sspi/SspiMasterList",
                method: "GET",
            }),
        }),
        // Sspi/SspiResponse
        getSspiResponse: builder.mutation({
            query: (assessmentResopnseConfig) => ({
                url: "Sspi/SspiResponse",
                method: "POST",
                body: assessmentResopnseConfig,
            }),
        }),
        getSspiResponseList: builder.mutation({
            query: () => ({
                url: "Sspi/SspiResponseList",
                method: "GET",
            }),
        }),
        // ---------------- SSPI API ----------------
        // ---------------- ASSIGNMENT API ----------------
        // assignment/AssignmentMasterList
        getAssignmentMaster: builder.mutation({
            query: () => ({
                url: "assignment/AssignmentMasterList",
                method: "GET",
            }),
        }),
        // assignment/AssignmentQuestionList
        getAssignmentQuestionList: builder.mutation({
            query: () => ({
                url: "assignment/AssignmentQuestionList",
                method: "GET",
            }),
        }),
        // Assignment/AssignmentQuestionListById?assignmentid=2
        getAssignmentQuestionListById: builder.mutation({
            query: (assignmentId) => ({
                url: `Assignment/AssignmentQuestionListById?assignmentid=${assignmentId}`,
                method: "GET",
            }),
        }),
        postAssignmentSubmission: builder.mutation({
            query: (assignmentResponseObj) => ({
                url: "assignment/AssignmentSubmission",
                method: "POST",
                body: assignmentResponseObj,
            }),
        }),
        postAssignmentTrackStart: builder.mutation({
            query: (assignmentTrackObj) => ({
                url: "assignment/AssignmentTrackStart",
                method: "POST",
                body: assignmentTrackObj,
            }),
        }),
        postAssignmentTrackEnd: builder.mutation({
            query: (assignmentTrackObj) => ({
                url: "assignment/AssignmentTrackEnd",
                method: "POST",
                body: assignmentTrackObj,
            }),
        }),
        getAssignmentTrackList: builder.mutation({
            query: (courseId) => ({
                url: `Assignment/AssignmentTrackList?courseid=${courseId}`,
                method: "GET",
            }),
        }),
        // ---------------- ASSIGNMENT API ----------------
        // ---------------- CLASS API ----------------
        getClassMasterList: builder.mutation({
            query: () => ({
                url: "Class/ClassMasterList",
                method: "GET",
            }),
        }),
        // ---------------- CLASS API ----------------
        // ---------------- MAPPING API ----------------
        getClassCourseMappingList: builder.mutation({
            query: () => ({
                url: "/classcoursemapping/ClassCourseMappingDetailList",
                method: "GET",
            }),
        }),
        getTeacherClassMappingDetailList: builder.mutation({
            query: () => ({
                url: "/TeacherClassMapping/TeacherClassMappingDetailList",
                method: "GET",
            }),
        }),
        // ---------------- MAPPING API ----------------
        getProjectSubmission: builder.mutation({
            query: () => ({
                url: "Project/ProjectSubmissionListById",
                method: "GET",
            }),
        }),
        getProjectMaster: builder.mutation({
            query: () => ({
                url: "project/ProjectMasterList",
                method: "GET",
            }),
        }),
        getBannerMaster: builder.mutation({
            query: () => ({
                url: "banner/BannerMasterList",
                method: "GET",
            }),
        }),
    }),
});

export const {
    useGetUserInfoMutation,
    useGetStudentDetailsMutation,
    useGetPointsMutation,
    useGetBadgesMutation,
    useGetCourseMasterMutation,
    useGetCourseSubDetailMutation,
    useGetCourseSubDetailsByCourseIdListMutation,
    useGetCourseDetailMutation,
    useGetCourseDetailsListByIdMutation,
    useGetCourseTrackStartMutation,
    useGetCourseTrackEndMutation,
    useGetCourseTrackListMutation,
    useGetCourseSubscriptionListMutation,
    useGetQuizMasterMutation,
    useGetQuizQuestionListMutation,
    useGetQuizQuestionByQuizIdListMutation,
    useGetQuizResponseMutation,
    useGetQuizResponseListMutation,
    useGetSspiExamListMutation,
    useGetSspiSubjectListMutation,
    useGetSspiQuestionListMutation,
    useGetSspiMasterListMutation,
    useGetSspiResponseMutation,
    useGetSspiResponseListMutation,
    useGetAssignmentMasterMutation,
    useGetAssignmentQuestionListMutation,
    useGetAssignmentQuestionListByIdMutation,
    usePostAssignmentSubmissionMutation,
    usePostAssignmentTrackStartMutation,
    usePostAssignmentTrackEndMutation,
    useGetAssignmentTrackListMutation,
    useGetClassMasterListMutation,
    useGetClassCourseMappingListMutation,
    useGetTeacherClassMappingDetailListMutation,
    useGetProjectSubmissionMutation,
    useGetProjectMasterMutation,
    useGetBannerMasterMutation,
} = apiSlice;
export default apiSlice;
